import type { CompanySettingEdit } from '~/models/CompanySetting';
import type { NskResponse } from '~/models/Api';
import { putRequest } from '~/utils/api/api_handler';

const paths = {
  update: '/company_settings'
} as const;

export const update = async (
  companySetting: CompanySettingEdit
): Promise<NskResponse> => putRequest(paths.update, { companySetting });
